import { useEffect, useRef, useState } from 'react';

export const useForceUpdateInterval = (
  lastDataUpdate: Date | null | undefined,
) => {
  const [, forceUpdate] = useState({});
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (!lastDataUpdate) {
      return;
    }

    const now = Date.now();
    const timeSinceUpdate = now - lastDataUpdate.getTime();
    const secondsSinceUpdate = Math.floor(timeSinceUpdate / 1000);

    // Wait to next minute: if <60s since update, wait to minute mark; if ≥60s, wait to next minute boundary
    const millisecondsToNextMinute =
      secondsSinceUpdate < 60
        ? (60 - secondsSinceUpdate) * 1000
        : (60 - (secondsSinceUpdate % 60)) * 1000;

    timeoutRef.current = setTimeout(() => {
      forceUpdate({});

      intervalRef.current = setInterval(() => {
        forceUpdate({});
      }, 60000);
    }, millisecondsToNextMinute);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [lastDataUpdate]);
};
